/** The profile the dashboard works on: the one chosen before if it still exists, else the first. */
export function pickActiveProfile<T extends { id: string }>(
  profiles: readonly T[],
  storedId: string | null,
): T | null {
  return profiles.find((profile) => profile.id === storedId) ?? profiles[0] ?? null
}
